/**
 * @file plugins.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _playerJs = require('./player.js');

var _playerJs2 = _interopRequireDefault(_playerJs);

/**
 * The method for registering a video.js plugin
 *
 * @param  {String} name The name of the plugin
 * @param  {Function} init The function that is run when the player inits
 * @method plugin
 */
var plugin = function plugin(name, init) {
  _playerJs2['default'].prototype[name] = init;
};

exports['default'] = plugin;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9qcy9wbHVnaW5zLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozt3QkFHbUIsYUFBYTs7Ozs7Ozs7Ozs7QUFTaEMsSUFBSSxNQUFNLEdBQUcsU0FBVCxNQUFNLENBQVksSUFBSSxFQUFFLElBQUksRUFBQztBQUMvQix3QkFBTyxTQUFTLENBQUMsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDO0NBQy9CLENBQUM7O3FCQUVhLE1BQU0iLCJmaWxlIjoic3JjL2pzL3BsdWdpbnMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEBmaWxlIHBsdWdpbnMuanNcbiAqL1xuaW1wb3J0IFBsYXllciBmcm9tICcuL3BsYXllci5qcyc7XG5cbi8qKlxuICogVGhlIG1ldGhvZCBmb3IgcmVnaXN0ZXJpbmcgYSB2aWRlby5qcyBwbHVnaW5cbiAqXG4gKiBAcGFyYW0gIHtTdHJpbmd9IG5hbWUgVGhlIG5hbWUgb2YgdGhlIHBsdWdpblxuICogQHBhcmFtICB7RnVuY3Rpb259IGluaXQgVGhlIGZ1bmN0aW9uIHRoYXQgaXMgcnVuIHdoZW4gdGhlIHBsYXllciBpbml0c1xuICogQG1ldGhvZCBwbHVnaW5cbiAqL1xudmFyIHBsdWdpbiA9IGZ1bmN0aW9uKG5hbWUsIGluaXQpe1xuICBQbGF5ZXIucHJvdG90eXBlW25hbWVdID0gaW5pdDtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IHBsdWdpbjtcbiJdfQ==